<template>
  <div>
    <TopBar
      :showCollapseButton="true"
      :showUserDropdown="true"
      :hideSupplierSelect="!passwordChanged"
      @collapse="onCollapseClicked"
    />

    <v-navigation-drawer
      :v-model="sideNavOpened"
      class="primary darken-1 d-none d-md-flex"
      dark
      app
      :mini-variant.sync="sideNavOpened"
      :mobile-breakpoint="960"
    >
      <SideNav :collapsed="!sideNavOpened" :routeItems="routeItems" />
    </v-navigation-drawer>

    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
import { AdminRouteItems } from "../../router";
import { SupplierRouteItems, VipRouteItems } from "../../router/routeItems";
import storage from "../../storage";

export default {
  data: () => ({
    drawer: null,
    temporary: false,
    isSideNavigatorOpened: true,
  }), // data

  mounted() {
    console.log('main container')
  }, // mounted

  computed: {
    passwordChanged() {
      return storage.local.getPasswordChanged();
    },
    userRoleName() {
      const roleName = storage.local.getUserRoleName();
      return roleName != null ? roleName.trim().toLowerCase() : undefined;
    },
    isUserVip() {
      return this.userRoleName == "vip";
    },
    isUserAdmin() {
      return this.userRoleName == "administrator";
    },
    isUserSupplier() {
      return this.userRoleName == "supplier";
    },
    sideNavOpened() {
      return this.$store.getters.getSideNavigatorOpened;
    },
    routeItems() {
      if (!this.passwordChanged) return [];
      if (this.isUserAdmin) return AdminRouteItems;
      if (this.isUserVip) return VipRouteItems;
      if (this.isUserSupplier) return SupplierRouteItems;
      return [];
    },
    getWindowsWidth() {
      return window.innerWidth;
    },
  }, // computed

  methods: {
    onCollapseClicked() {
      const current = this.$store.getters.getSideNavigatorOpened;
      this.isSideNavigatorOpened = current;

      this.$store.commit("setSideNavigatorOpened", !current);
      if (window.innerWidth < 960) {
        this.drawer = !this.drawer;
        this.temporary = !this.temporary;
      }
    },

    onRouteItem($event) {
      $event.showChildren = !$event.showChildren;

      if ($event.path != null && $event.path.length > 0)
        this.$router.push({ path: $event.path });
    },
  }, // methods
};
</script>
